import type { Item, ArticleCarouselType } from '../../types';

export const isArticleCarousel = (item: Item): item is ArticleCarouselType => {
	return !!(item && item.__typename === 'Article_Carousel');
};
